module.exports = __webpack_public_path__ + "media/assets/images/logos/logo_nexa-d2096a3d6090c0c1f8563fb5ffa97429.png";